// 兑奖记录页（聚合：所有 redeeming/redeemed/redeem_failed 订单）
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Box, Card, CardContent, Typography, CircularProgress } from '@mui/material';
import RlPageHeader from '../../components/real-lottery/RlPageHeader';
import OrderCard from '../../components/real-lottery/OrderCard';
import { getCurrentRlUser } from '../../components/real-lottery/useRlUser';
import { listRlOrders, getRlRedeemStatus } from '../../services/realLotteryApi';

export default function RealLotteryRedemptionsPage() {
  const history = useHistory();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async (userId) => {
    setLoading(true);
    const res = await listRlOrders({ userId, status: 'won', page: 1, pageSize: 50 });
    if (res.success) {
      // 仅显示已提交兑奖的（status in [redeeming, redeemed, redeem_failed]）
      const filtered = res.data.list.filter((o) =>
        ['redeeming', 'redeemed', 'redeem_failed'].includes(o.status)
      );
      setOrders(filtered);
    }
    setLoading(false);
  };

  useEffect(() => {
    const u = getCurrentRlUser();
    if (!u) { history.replace('/login-v2'); return; }
    setUser(u);
    load(u.userId);
  }, []);

  const handleAction = async (action, order) => {
    if (action === 'refreshRedeem') {
      await getRlRedeemStatus(order.outTradeNo);
      if (user) load(user.userId);
    }
  };

  return (
    <Box sx={{ backgroundColor: '#f5f5f7', minHeight: '100vh', pb: 4 }}>
      <RlPageHeader title="兑奖记录" />
      <Container maxWidth="sm" sx={{ pt: 2 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
            <CircularProgress />
          </Box>
        ) : orders.length === 0 ? (
          <Card sx={{ borderRadius: 2 }}>
            <CardContent sx={{ textAlign: 'center', py: 6 }}>
              <Typography color="text.secondary">还没有兑奖记录</Typography>
            </CardContent>
          </Card>
        ) : (
          orders.map((o) => <OrderCard key={o.outTradeNo} order={o} onAction={handleAction} />)
        )}
      </Container>
    </Box>
  );
}
